import { BareButton } from '@calendly/ui/components/bare-button';
import { OptionsUI, OptionUI } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { getLabelForKind } from '../utils';
const allOptionsDropdownContainerCss = "ajdjtyp";
const AllOptionsDropdownContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(allOptionsDropdownContainerCss, props.className)} />;
});
const iconWrapperCss = "i1p9w7r7";
const IconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconWrapperCss, props.className)} />;
});
const locationOptionWrapperCss = "l1gemr4t";
const LocationOptionWrapper = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(locationOptionWrapperCss, props.className)} />);
const LocationOptionBody = ({
  kind
}) => <>
    <IconWrapper>
      <LocationIcon useNewIcons kind={kind} />
    </IconWrapper>
    <BodyText as="span">{getLabelForKind(kind)}</BodyText>
  </>;
const LocationOption = ({
  kind,
  updateAction
}) => <LocationOptionWrapper onClick={() => updateAction(kind)}>
    <LocationOptionBody kind={kind} />
  </LocationOptionWrapper>;
const MobileOption = ({
  updateSelectedKind,
  kind
}) => <OptionUI onClick={() => updateSelectedKind(kind)}>
    <LocationOptionBody kind={kind} />
  </OptionUI>;
const MobileLocationList = forwardRef(({
  updateSelectedKind,
  availableKinds
}, ref) => <OptionsUI ref={ref}>
    {availableKinds.map(kind => <MobileOption key={kind} kind={kind} updateSelectedKind={updateSelectedKind} />)}
  </OptionsUI>);
export const LocationOptionList = forwardRef(({
  updateSelectedKind,
  availableKinds,
  className
}, ref) => {
  const isPhone = useDeviceType('isPhone');
  if (isPhone) {
    return <MobileLocationList ref={ref} updateSelectedKind={updateSelectedKind} availableKinds={availableKinds} />;
  }
  return <AllOptionsDropdownContainer ref={ref} className={className}>
      {availableKinds.map(kind => <LocationOption key={kind} kind={kind} updateAction={updateSelectedKind} />)}
    </AllOptionsDropdownContainer>;
});

require("./location_option_list.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_option_list.js");